import { Provider } from '@angular/core';

import { TagsApiService } from './tags-api.service';
import { TagsHttpService } from './tags-http.service';

/** Registra la implementación de `TagsApiService` que usa la app. */
export function provideTags(): Provider[] {
  return [{ provide: TagsApiService, useClass: TagsHttpService }];
}
